// /client/packs/controllers/ccpa_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.validate()
  }

  handleSubmit(event) {
    event.preventDefault()
    this.validate()

    if (!this.submitTarget.disabled) {
      this.element.submit()
    }
  }

  validate() {
    let invalidFields = []
    this.element.querySelectorAll("input:not(button, [type='submit'])").forEach(el => {
      if (el.classList.contains("is-invalid")) { 
        invalidFields.push(el)
      }
    })
    this.submitTarget.disabled = invalidFields.length != 0
  }
}